<template>
  <div id="app" :class="{ rtl: $i18n.locale === 'AR' }">
    <!-- 头部 -->
    <Head></Head>
    <router-view />

    <!-- 维护 -->
    <Maintain v-if="maintainis" :maintain_data="maintain_data" />
    <!-- 切换角色框 -->
    <ToggleRole />
    <!-- 版本更新 -->
    <VersionUpdate />
    <!-- cookie -->
    <Accept />

    <!-- 全局loading -->
    <Loading v-show="showLoading" />

    <!-- 确认同意框 -->
    <Agree />

    <!-- 税率提示框 -->
    <ProductionTaxTips
      @confirm="confimProductionTaxTips"
      v-if="isLogin && isShowProductionTaxTips && isProductionTax"
    />
    <!-- tooltips 提示框 -->
    <Tooltips />
  </div>
</template>

<script>
import Head from '@/components/common/head/index.vue'
import Accept from '@/components/common/accept.vue'
import Maintain from '@/components/common/maintain.vue'
import VersionUpdate from '@/components/common/VersionUpdate.vue'
import Loading from '@/components/common/loading.vue'
import ToggleRole from '@/components/common/loginModal/toggleRole.vue'
import { mapState } from 'vuex'
const web_shop_version = require('/version.js')
import Agree from '@/components/common/loginModal/Agree.vue'
import ProductionTaxTips from '@/components/common/productionTaxTips.vue'
import Tooltips from '@/components/common/Tooltips.vue'
import { confirmTaxNotice } from '@/api'
import { generateEncryptedAesKey, getPublicKey } from '@/tool/encryptor'
export default {
  name: 'App',
  components: {
    Head,
    Accept,
    Loading,
    Maintain,
    ToggleRole,
    VersionUpdate,
    Agree,
    ProductionTaxTips,
    Tooltips,
  },
  computed: {
    ...mapState({
      showLoading: (state) => state.app.showLoading,
      isNewWebsite: (state) => state.app.isNewWebsite,
      isLogin: (state) => state.user.isLogin,
      isProductionTax: (state) => state.app.isProductionTax,
      isShowProductionTaxTips: (state) => state.user.isShowProductionTaxTips,
    }),
  },
  data() {
    return {
      switchActive: false,
      maintainis: false,
      maintain_data: {
        maintain_notice: '',
        show_maintain_time: '',
        maintain_end_time: '',
        now_time: '',
      },
    }
  },
  created() {
    const publicKey = getPublicKey()
    const { aesKey, encryptedAesKey } = generateEncryptedAesKey(publicKey)
    this.$store.commit('app/SET_AES_KEY', aesKey)
    this.$store.commit('app/SET_ENCRYPTED_AES_KEY', encryptedAesKey)
    this.init()
    //挂维护
    this.$root.Bus.$on('maintain', (obj) => {
      this.maintain_data = obj
      this.maintainis = true
    })

    this.$rum.report('app_created', {})

    window.addEventListener('resize', this.updateDeviceType)
  },
  mounted() {},
  methods: {
    confimProductionTaxTips() {
      confirmTaxNotice({
        game_id: process.env.VUE_APP_GAME_ID,
      })
      this.$store.commit('SET_IS_SHOW_PRODUCTION_TAX_TIPS', false)
    },
    init() {
      this.$ta.setSuperProperties({
        sysversion: web_shop_version[0],
      })
    },
    updateDeviceType() {
      this.$store.commit('app/SET_IS_MOBILE')
    },
  },
}
</script>

<style>
@media (max-width: 1024px) {
  .hidden_m {
    display: none !important;
  }
}
@media (min-width: 1024px) {
  .hidden_pc {
    display: none !important;
  }
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 101;
  width: 100vw;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.6);
}

.successlevel {
  z-index: 101;
}
.mask_main_content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  max-width: 750px;
  width: 90%;
  box-sizing: border-box;
}

/* kakao按钮样式 */
#kakaodropin .adyen-checkout__button {
  height: 40px;
}

#paypaydropin .adyen-checkout__button {
  height: 40px;
}
</style>
